import {
  FETCH_RETAILERS_LIST,
  RESET_RETAILERS_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const retailersListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RETAILERS_LIST:
      return { list: action.payload, others: action.others };
    case RESET_RETAILERS_LIST:
      return initialState;
    default:
      return state;
  }
};

export default retailersListReducer;
